import WorkAnniversaryCard from './workAnniversaryCard';
export default WorkAnniversaryCard;